// src/components/ProtectedRoute.tsx

import { Outlet } from "react-router-dom";
import BillingInfoModal from "@/components/billing/BillingInfoModal";
import { ThemeSync } from "@/components/ThemeSync";
import { useActivityMark } from "@/hooks/useActivityMark";

// Billing gating happens inside Layout/ResearchLayout, around just the routed
// page content — not here — so the sidebar (Settings, Refer a Friend, Roadmap,
// Contact Us, Logout) stays visible and usable even once a user is blocked.
const ProtectedRoute = () => {
  // Daily-active signal for a tab left open past midnight. See useActivityMark.
  useActivityMark();

  return (
    <>
      <ThemeSync />
      <BillingInfoModal />
      <Outlet />
    </>
  );
};

export default ProtectedRoute;
